<template>
  <div id="index" ref="appRef">
    <div class="host-body">
      <!-- 顶部 -->
      <div class="topbg">
        <div class="tabs">
          <div>
            <router-link
              :class="pathRoute == '/main/weather' || pathRoute == '/main/weatherEquipment' ? 'tab_item_focus' : 'tab_item'"
              to="/main/weatherEquipment">温室环境信息</router-link>
            <router-link
              :class="pathRoute == '/main/cqData' || pathRoute == '/main/cqDataInfo' ? 'tab_item_focus' : 'tab_item'"
              to="/main/cqDataInfo">虫情监测</router-link>
            <router-link
              :class="pathRoute == '/main/manure' || pathRoute == '/main/manureInfo' ? 'tab_item_focus' : 'tab_item'"
              to="/main/manureInfo">水肥一体化</router-link>
            <!-- <div :class="pathRoute == it.path ? 'bottombgactive' : 'bottombg'"></div> -->
          </div>
          <!-- <div class="check">
            <input type="checkbox" v-model="checked" @change="changeChecked">帷幕
          </div> -->
        </div>
        <div class="title" v-if="selectFlag == false">{{ projectData.name }}</div>
        <div class="select_project" v-else>
          <el-select v-model="projectName" placeholder="请选择" @change="changeProject">
            <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="tips">
          <div class="temperature">
            <i :class="weatherData.icon"></i>
            <span class="num">{{ weatherData.temp }}</span>
            <span class="unit">℃</span>
          </div>
          <div class="weather">{{ weatherData.text }}</div>
          <div class="address">{{ projectData.cityName }}</div>
          <div class="other">
            <!-- <p class="sunLight">紫外线低</p> -->
            <p class="wind">{{ weatherData.windDir }}</p>
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div class="contain-body">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { getProject, getWeather } from "../api/api";
import drawMixin from "../utils/drawMixin";
export default {
  mixins: [drawMixin],
  data() {
    return {
      data: [
        { name: "温室环境信息", path: "/main/weather" },
        { name: "虫情监测", path: "/main/cqData" },
        { name: "水肥一体化", path: "/main/manure" },
      ],
      pathRoute: "",
      // 帷幕
      checked: false,
      // 项目信息
      projectData: {},
      projectName: "",
      lng: "",
      lat: "",
      weatherData: {},
      // 下拉框
      projectList: [],
      selectFlag: false,
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        // console.log(val.path);
        this.pathRoute = val.path
        if (this.pathRoute == "/main/weatherEquipment" || this.pathRoute == "/main/cqDataInfo" || this.pathRoute == "/main/manureInfo") {
          this.checked = true
        } else {
          this.checked = false
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  beforeMount() {
    this.pathRoute = this.$route.path

    this.cancelLoading()
  },

  mounted() {
    this.getProject()
  },

  methods: {
    // 获取项目信息
    async getProject() {
      let res = await getProject()
      console.log(res, "项目信息");
      if (res.code == 200) {
        this.projectData = res.data[0]
        this.projectList = res.data
        this.projectName = this.projectData.name
        window.localStorage.setItem('projectId', JSON.stringify(res.data[0].id))
        if (res.data.length <= 1) {
          this.selectFlag = false
        } else {
          this.selectFlag = true
        }
        this.lat = res.data[0].latitude
        this.lng = res.data[0].longitude
        this.getWeather()
      }
    },

    // 获取天气信息
    async getWeather() {
      let res = await getWeather({
        location: this.lng + "," + this.lat,
        type: 0
      })
      console.log(res, "天气数据");
      if (res.code == 200) {
        this.weatherData = res.data.now
        this.weatherData.icon = 'qi-' + this.weatherData.icon
      }
    },

    // 切换项目信息
    changeProject(e) {
      // localStorage.setItem('projectId', e)
      window.localStorage.setItem('projectId', JSON.stringify(e))
      this.projectList.forEach(item => {
        if (item.id == e) {
          this.projectData = item
          this.lat = item.latitude
          this.lng = item.longitude
          this.getWeather()
        }
      })
      // this.$router.go(1)
    },

    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 帷幕选中状态改变
    changeChecked() {
      console.log(this.pathRoute, "当前路由");
      if (this.pathRoute == "/main/weatherEquipment") {
        this.$router.push({
          path: "/main/weather"
        })
      }
      if (this.pathRoute == "/main/cqDataInfo") {
        this.$router.push({
          path: "/main/cqData"
        })
      }
      if (this.pathRoute == "/main/manureInfo") {
        this.$router.push({
          path: "/main/manure"
        })
      }
    },
  },

}
</script>
<style lang="scss" scoped>
@import '../assets/scss/index.scss';

.host-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // background: radial-gradient(circle, #041768 0%, #020C34 100%);
  font-family: SourceHanSansSC-regular;

  .topbg {
    background-color: rgba(255, 255, 255, 0.88);
    height: 127px;
    padding: 36px 45px 46px 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tabs {
      display: flex;
      align-items: center;

      .tab_item {
        box-sizing: border-box;
        padding: 14px 10px;
        margin-right: 10rpx !important;
        line-height: 26px;
        font-size: 18px;
        color: #000;
        font-family: Roboto;
      }

      .tab_item_focus {
        box-sizing: border-box;
        padding: 14px 10px;
        margin-right: 10rpx !important;
        line-height: 26px;
        font-size: 18px;
        border-radius: 17px;
        background-color: rgba(129, 179, 55, 0.83);
        color: #fff;
      }

      .check {
        margin-left: 15px;
        color: #000;
        font-size: 26px;
        display: flex;
        align-items: center;

        input[type=checkbox] {
          cursor: pointer;
          position: relative;
          width: 30px;
          height: 30px;
          font-size: 20px;
          margin-right: 10px;
        }

        input[type=checkbox]::after {
          position: absolute;
          top: 0;
          border: none;
          /* background-color: #ff670c; */
          color: #fff;
          width: 30px;
          height: 30px;
          display: inline-block;
          visibility: visible;
          padding-left: 0px;
          text-align: center;
          content: ' ';
          border-radius: 1px
        }

        input[type=checkbox]:checked::after {
          background-color: rgba(129, 179, 55, 0.83);
          border-color: rgba(129, 179, 55, 0.83);
          content: "✓";
          font-size: 20px;
          font-weight: bold;
        }

      }
    }

    .title {
      color: #000;
      font-size: 36px;
      text-align: center !important;
    }

    .select_project {
      ::v-deep .el-input__inner {
        border: none;
        width: 750px;
        font-size: 30px;
        color: #000;
        text-align: center;

      }

      ::v-deep.el-select .el-input .el-select__caret {
        font-size: 28px;
      }
    }

    .tips {
      display: flex;
      align-items: center;
      color: #000;

      .temperature {
        margin-right: 10px;

        i {
          font-size: 33px;
        }

        .num {
          font-size: 36px;
        }

        .unit {
          font-size: 14px;
          vertical-align: top;
        }
      }

      .weather {
        font-size: 14px;
        margin-right: 20px;
      }

      .address {
        margin-right: 20px;
        font-size: 20px;
      }

      .other {
        font-size: 14px;

        .sunLight {}

        .wind {
          text-align: center;
          line-height: 20px;
          background-color: #000;
          color: rgba(255, 255, 255, 1);
          padding: 0 2px;
        }
      }
    }

  }

  .contain-body {
    flex-grow: 1;

    .contain-body-content {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
